import { AppState } from 'src/app/app.state';

import { GlobalSearchActionTypes } from '../../actions/global-search/global-search.actions';

import { GlobalSearchResults } from 'src/app/shared/models/global-search/GlobalSearchResults';

export interface GlobalSearchState {
  searchResults: GlobalSearchResults;
  error?: string;
  loaded: boolean;
  loading: boolean;
  searchQuery: string;
  visible: boolean;
}

const initialState: GlobalSearchState = {
  searchResults: <GlobalSearchResults>{
    tickets: [],
    serviceCatalogItems: [],
    knowledgeModelItems: []
  },
  searchQuery: null,
  error: null,
  loaded: null,
  loading: null,
  visible: true
};

export function globalSearchReducer(
  state: GlobalSearchState = initialState,
  action: any
): GlobalSearchState {
  switch (action.type) {
    case GlobalSearchActionTypes.SEARCH:
      return {
        ...state,
        searchQuery: action.searchQuery,
        loading: true
      };
    case GlobalSearchActionTypes.SET_VISIBLE:
      return {
        ...state,
        visible: action.visible
      };
    case GlobalSearchActionTypes.SEARCH_SUCCESS:
      return {
        ...state,
        searchResults: action.searchResults,
        error: null,
        loading: false,
        loaded: true
      };

    case GlobalSearchActionTypes.SEARCH_ERROR:
      return {
        ...state,
        searchResults: <GlobalSearchResults>{
          tickets: [],
          serviceCatalogItems: [],
          knowledgeModelItems: []
        },
        error: action.error,
        loading: false,
        loaded: false
      };

    default:
      return state;
  }
}

export const getGlobalSearchState = (state: AppState) => state.globalSearch;

export const getGlobalSearchResults = (state: GlobalSearchState) =>
  state.searchResults;
export const getGlobalSearchResultsError = (state: GlobalSearchState) =>
  state.error;
export const getGlobalSearchLoading = (state: GlobalSearchState) =>
  state.loading;
export const searchResultsVisible = (state: GlobalSearchState) => state.visible;
export const getSearchQuery = (state: GlobalSearchState) => state.searchQuery;
